var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindDir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 30 30",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-571.26 -413.22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-122.6 -194.34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.832 0 0 1.6667 -547.49 -411.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 677.6,
    y: 611.59,
    width: 16.097,
    height: 17.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.36875 8.6865e-17 2.2724e-15 -.36875 708.61 623.31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.85537 0 0 .9174 3.4711 1.659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.344 43.322c-1.273 0.581-2.805 0.317-3.772-0.65l-1e-3 -1e-3c-0.653-0.653-0.839-1.6-0.476-2.427 2.217-5.056 10.091-23.008 14.264-32.523 0.439-1 1.482-1.653 2.641-1.653s2.202 0.653 2.641 1.653c4.173 9.515 12.047 27.467 14.264 32.523 0.363 0.827 0.177 1.774-0.476 2.427l-1e-3 1e-3c-0.967 0.967-2.499 1.231-3.772 0.65-3.39-1.546-9.819-4.478-11.95-5.45-0.445-0.203-0.967-0.203-1.412 0-2.131 0.972-8.56 3.904-11.95 5.45z",
    fill: "#e7e7eb",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDir);
export default __webpack_public_path__ + "static/media/wind_dir.df4a330c306502e6573d3ea6413761ad.svg";
export { ForwardRef as ReactComponent };